/* eslint-disable vue/component-definition-name-casing */
import Vue from 'vue'
import Datepicker from 'vuejs-datepicker'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('date-picker', Datepicker)
